import { exists, SystemCode, SystemCodeFromJSON } from '@/api'
import { defaultSystemCode } from '@/api/models/system-code/SystemCode'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'

export interface CollectionReserveProcessInfo {
  id: number
  collectionNo: string
  reserveId: number
  reserveStatus: SystemCode
  userId: string
  userName: string
  contactMethod: SystemCode
  forwardingBranchCode: SystemCode
  handlingType: SystemCode
  appendixCode: SystemCode
  holdingBranchCode: SystemCode
  shelfType: SystemCode
  specifyCollectionId: string
  displayMemo: string
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SystemCode
  displayTitle: string
  displayAuthor: string
  collectionFlag: CollectionFlag
  nextReserveAssign: boolean
  receiptInfoReserve: any // 可変値のためanyとする
  receiptInfoReserveForwarding: any // 可変値のためanyとする
}

export function CollectionReserveProcessInfoFromJSON(
  json: any
): CollectionReserveProcessInfo {
  return {
    id: exists(json, 'id') ? json.id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    reserveId: exists(json, 'reserve_id') ? json.reserve_id : 0,
    reserveStatus: exists(json, 'reserve_status')
      ? SystemCodeFromJSON(json.reserve_status)
      : defaultSystemCode(),
    userId: exists(json, 'user_id') ? json.user_id : '',
    userName: exists(json, 'user_name') ? json.user_name : '',
    contactMethod: exists(json, 'contact_method')
      ? SystemCodeFromJSON(json.contact_method)
      : defaultSystemCode(),
    forwardingBranchCode: exists(json, 'forwarding_branch_code')
      ? SystemCodeFromJSON(json.forwarding_branch_code)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    specifyCollectionId: exists(json, 'specify_collection_id')
      ? json.specify_collection_id
      : '',
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Set,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    nextReserveAssign: exists(json, 'next_reserve_assign')
      ? json.next_reserve_assign
      : false,
    receiptInfoReserve: exists(json, 'receipt_info_reserve')
      ? json.receipt_info_reserve
      : undefined,
    receiptInfoReserveForwarding: exists(
      json,
      'receipt_info_reserve_forwarding'
    )
      ? json.receipt_info_reserve_forwarding
      : undefined
  }
}
